import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  spacing, breakpoints, palette, fontFamilies, fontSizes, lineHeights,
}: Theme) => ({
  bonusesList: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: spacing(1.5),
    listStyleType: 'none',
    padding: 0,
    margin: '0 0 20px',
    [breakpoints.up('sm')]: {
      margin: '0 0 32px',
      gap: spacing(2),
    },
  },
  bonusesItem: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: spacing(1),
    [breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: spacing(1.5),
    },
  },
  description: {
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.sm,
    color: palette.text.primary,
    [breakpoints.up('sm')]: {
      fontSize: fontSizes.md,
      lineHeight: lineHeights.lg,
    },
  },
}));
